<template>
  <v-card
    v-if="showCard"
    id="import-modal-errored-card"
    class="pb-1"
    :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
  >
    <v-card-title>
      {{ $t(`views.imports.importModal.importModalErroredCard.title`) }}
    </v-card-title>

    <v-card-text class="py-0 mb-0 mt-2">
      <div class="text-center mt-7 mb-4">
        <v-icon color="softRed" size="50">mdi-text-box-remove</v-icon>
      </div>
      <div v-if="myImport.error && myImport.error.name === 'import.rowsLimit'">
        <p class="pt-2">
          <span>
            {{ $t(`views.imports.importModal.importModalErroredCard.rowsLimitError`) }}
          </span>
        </p>
      </div>
      <div v-else>
        <p class="pt-2">
          <span>
            {{ $t(`views.imports.importModal.importModalErroredCard.description1`) }}
          </span>
        </p>
        <p v-if="myImport.type === 'order' || myImport.type === 'dividend'">
          <v-icon color="primary">mdi-check</v-icon>
          {{ $t(`views.imports.importModal.importModalErroredCard.descriptionOrderDividend1`) }}
          <a href="https://www.filios.app/tutoriales/#importacion-automatica" target="_blank">
            <b>
              {{ $t(`views.imports.importModal.importModalErroredCard.descriptionOrderDividend2`) }}
            </b>
          </a>
          {{ $t(`views.imports.importModal.importModalErroredCard.descriptionOrderDividend3`) }}
        </p>
        <p v-if="myImport.type === 'orderGeneric' || myImport.type === 'dividendGeneric'">
          <v-icon color="primary">mdi-check</v-icon>
          {{
            $t(`views.imports.importModal.importModalErroredCard.descriptionOrderDividendGeneric1`)
          }}
          <a
            href="https://www.filios.app/blog/como-hacer-una-importacion-generica-en-filios/"
            target="_blank"
          >
            <b>
              {{
                $t(
                  `views.imports.importModal.importModalErroredCard.descriptionOrderDividendGeneric2`
                )
              }}
            </b>
          </a>
        </p>

        <p v-if="myImport.type === 'order' || myImport.type === 'orderGeneric'">
          <v-icon color="primary">mdi-check</v-icon>
          {{ $t(`views.imports.importModal.importModalErroredCard.descriptionCorrectTabOrder`) }}
        </p>
        <p v-else-if="myImport.type === 'dividend' || myImport.type === 'dividendGeneric'">
          <v-icon color="primary">mdi-check</v-icon>
          {{ $t(`views.imports.importModal.importModalErroredCard.descriptionCorrectTabDividend`) }}
        </p>
        <p class="mb-0">
          <span>
            {{ $t(`views.imports.importModal.importModalErroredCard.contact.a`) }}
          </span>
          <a href="https://www.filios.app/contacta" target="_blank">
            <b>{{ $t(`views.imports.importModal.importModalErroredCard.contact.b`) }}</b>
          </a>
          <span>
            {{ $t(`views.imports.importModal.importModalErroredCard.contact.c`) }}
          </span>
        </p>
      </div>
    </v-card-text>
    <v-card-actions class="mt-3">
      <v-spacer />
      <v-btn class="mr-1" text :small="$vuetify.breakpoint.smAndDown" @click="$emit('close')">
        {{ $t('common.close') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import gtag from '@/lib/gtag'

export default {
  props: {
    myImport: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    showCard() {
      const showCard = this.myImport.status === 'errored'

      if (showCard)
        gtag.pageview({
          pagePath: `/input/${this.type === 'order' ? 'orders' : 'dividends'}/import/errored`,
          pageTitle: `input|${this.type === 'order' ? 'orders' : 'dividends'}|import|errored`,
          pageContentGroup: 'modal',
        })

      return showCard
    },
  },
  methods: {},
}
</script>

<style lang="scss">
#import-modal-errored-card {
  p {
    font-size: 15px;
  }
}
</style>
